
















































































































import { LayoutModule } from "@/store/layout";
import { UserModule } from "@/store/user";
import { Component, Vue } from "vue-property-decorator";
import { Auth } from "aws-amplify";
import { Alert } from "@/models/general";

@Component
export default class CompleteRegistration extends Vue {
  appLogo = require("@/assets/app-logo.png");
  showPassword = false;
  model = {
    name: "",
    familyName: "",
    newPassword: "",
    confirmPassword: "",
  };
  loading = false;

  get cognitoUser(): any {
    return UserModule.cognitoUser;
  }

  validate(): void {
    const validForm = (this.$refs.form as Vue & {
      validate: () => boolean;
    }).validate();
    validForm ? this.completeRegistration() : null;
  }

  async completeRegistration(): Promise<void> {
    this.loading = true;
    LayoutModule.cleanAlerts();
    try {
      const user = await Auth.completeNewPassword(
        UserModule.getCognitoUser,
        this.model.newPassword,
        {
          name: this.model.name,
          family_name: this.model.familyName,
        }
      );

      this.$router.push({ name: "home" });
    } catch (error) {
      console.log(error);

      const e: Alert = {
        type: "error",
        text: this.$t(`auth.responses.${error.name}`).toString(),
      };

      LayoutModule.setAlerts(e);
    } finally {
      this.loading = false;
    }
  }
}
